// Central site config for The Greater Bull ($TGB)
export const SITE = {
  name: "THE GREATER BULL",
  ticker: "$TGB",
  tagline: "The Next 1000x. Community Powered. Long Term. Legendary.",
  contractAddress: "FWAL41iCEHYncRYi24Cmtz7onu8UwafhZviTta7Wpump",
  links: {
    pumpfun: "https://pump.fun/coin/FWAL41iCEHYncRYi24Cmtz7onu8UwafhZviTta7Wpump",
    dexscreener: "https://dexscreener.com/solana/37dzjf6kzah2948zfsnjvv5yj9w7v7rt2chonmdw9kve",
    twitter: "https://x.com/thegreaterbull",
    telegram: "https://t.me/TheGreaterBull",
  },
  // Dexscreener embed uses the pair address
  dexPair: "37dzjf6kzah2948zfsnjvv5yj9w7v7rt2chonmdw9kve",
};

export const IMAGES = {
  heroBull: "https://static.prod-images.emergentagent.com/jobs/864859fa-1dc3-41ba-83da-16c24a7d25a3/images/41bab727cb4bbadedd3beb30c0af1e42e2aa72ae510607c24f4787471f702d6b.png",
  ogBanner: "https://static.prod-images.emergentagent.com/jobs/864859fa-1dc3-41ba-83da-16c24a7d25a3/images/0cd2aa7dd412e76ea62df222942190b0cad247f54c6ba84bd6d19d31b7ab3229.png",
  memeMoon: "https://static.prod-images.emergentagent.com/jobs/864859fa-1dc3-41ba-83da-16c24a7d25a3/images/fdc0a41aced01329c4f94805d82dcbc5437fd10a290d28218021fdab183526df.png",
  memeChad: "https://static.prod-images.emergentagent.com/jobs/864859fa-1dc3-41ba-83da-16c24a7d25a3/images/f4e6491783893ee28c9135c506444f28184571e38da99fd69a808d22d3fc23ff.png",
  memeChart: "https://static.prod-images.emergentagent.com/jobs/864859fa-1dc3-41ba-83da-16c24a7d25a3/images/209cd0da2fd95e4a06c34c6659f31c853c00bd268c1174ea363e51a1f6f494a9.png",
  memeKing: "https://static.prod-images.emergentagent.com/jobs/864859fa-1dc3-41ba-83da-16c24a7d25a3/images/bb89f99a3801d580a5c65570b7e96e0ea981822bb8a24a21889864a9a38232ff.png",
};

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Chart", href: "#chart" },
  { label: "Tokenomics", href: "#tokenomics" },
  { label: "How to Buy", href: "#how-to-buy" },
  { label: "Roadmap", href: "#roadmap" },
  { label: "Community", href: "#community" },
];

export const TOKENOMICS = [
  { label: "Total Supply", value: "2,000,000,000", suffix: "$TGB", color: "gold" },
  { label: "Buy / Sell Tax", value: "0%", suffix: "Forever", color: "ember" },
  { label: "Liquidity", value: "BURNED", suffix: "100% Locked", color: "blood" },
  { label: "Community Owned", value: "100%", suffix: "Fair Launch", color: "solana" },
];

export const STEPS = [
  {
    title: "Get a Solana Wallet",
    desc: "Download Phantom (or Solflare) on mobile or as a browser extension. It's free and takes under a minute.",
  },
  {
    title: "Fund with SOL",
    desc: "Buy SOL on any exchange and send it to your wallet — or buy directly inside Phantom with a card.",
  },
  {
    title: "Visit Pump.fun",
    desc: "Head to our official Pump.fun page and connect your wallet. Always verify the contract address first.",
  },
  {
    title: "Swap for $TGB",
    desc: "Enter the amount of SOL, hit buy, and welcome to the stampede. You're now part of The Greater Bull.",
  },
];

export const ROADMAP = [
  {
    phase: "Phase 1",
    title: "The Ignition",
    status: "done",
    items: ["Fair launch on Pump.fun", "Website & socials live", "Community ignition", "First 500 holders"],
  },
  {
    phase: "Phase 2",
    title: "The Stampede",
    status: "active",
    items: ["1,000+ holders", "Dexscreener trending", "Meme army mobilized", "CoinGecko & CMC listings"],
  },
  {
    phase: "Phase 3",
    title: "The Charge",
    status: "upcoming",
    items: ["10,000+ holders", "Tier-1 CEX listings", "Influencer partnerships", "Official $TGB merch drop"],
  },
  {
    phase: "Phase 4",
    title: "World Domination",
    status: "upcoming",
    items: ["100,000+ holders", "Global brand recognition", "Community treasury & DAO", "The Greater Bull becomes legend"],
  },
];
